import React from 'react';

function SearchBar({ searchTerm, onSearch, onReset }) {
  return (
    <div className="search-bar">
      <div className="search-container">
        <input
          type="text"
          placeholder="Search films by title, genre, director, or year..."
          value={searchTerm}
          onChange={(e) => onSearch(e.target.value)}
          className="search-input"
        />
        {searchTerm && (
          <button 
            onClick={onReset}
            className="reset-btn"
            title="Clear search"
          >
            ✕
          </button>
        )}
      </div>
      {searchTerm && (
        <p className="search-info">Searching: "{searchTerm}"</p>
      )}
    </div>
  );
}

export default SearchBar;